module.exports = __webpack_public_path__ + "img/identification.0e907d1b.svg";